/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_TracksInputs */

const en_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output audio tracks`)
};

const fr_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistes audio de sortie`)
};

const de_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioausgabespuren`)
};

const it_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracce audio in uscita`)
};

const ru_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выходные аудиодорожки`)
};

const es_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistas de audio de salida`)
};

const zh_cn2_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出音频轨道`)
};

const ja_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力オーディオトラック`)
};

const hi_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट ऑडियो ट्रैक`)
};

const pt_pt2_audio_embed_export_output_tracks = /** @type {(inputs: Audio_Embed_Export_Output_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixas de áudio de saída`)
};

/**
* | output |
* | --- |
* | "Output audio tracks" |
*
* @param {Audio_Embed_Export_Output_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_tracks = /** @type {((inputs?: Audio_Embed_Export_Output_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_tracks(inputs)
	if (locale === "de") return de_audio_embed_export_output_tracks(inputs)
	if (locale === "it") return it_audio_embed_export_output_tracks(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_tracks(inputs)
	if (locale === "es") return es_audio_embed_export_output_tracks(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_tracks(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_tracks(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_tracks(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_tracks(inputs)
	return en_audio_embed_export_output_tracks(inputs)
});